<div class="container-fluid text-center p-0" (mouseenter)="this.dotComService.DisplaySubMenu('')">

    <!-- Polyon Modal -->
    <div id="howItWorksModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content howItWorksModalVideoModalMobile">
            <!-- MUST PATH TO A VIRTUAL DIRECTORY AND NOT AZURE STOREAGE FOR This
            BECAUSE VIDEOS DO NOT HAVE THE SKIP AHEAD FUNCTIONALITY WITH AZURE STORAGE 
            THIS IS DUE TO THE WAY AZURE BLOB STORAGES STREAMS THE MP4 -->
            <video id="howItWorksVideo" class="howItWorksModalMobile" width="800" height="500" controls>
                <source src="https://harrellspublic2024.azurewebsites.net/Assets/Images/How_POLYON_Works.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <h6 style="text-align: right;margin-top:20px; margin-right:20px"><a
                    class="DIN2014 greenBackground whiteText"
                    style="cursor:pointer;font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                    (click)="ClosehowItWorksModal()">Close</a></h6>
        </div>
    </div>
    <!-- End Polyon Modal -->

    <!-- Core Values Modal -->
    <div id="coreValuesModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content coreValuesModalVideoModalMobile">
            <video id="coreValuesVideo" class="coreValuesModalMobile" width="800" height="500" controls>
                <!-- MUST PATH TO A VIRTUAL DIRECTORY AND NOT AZURE STOREAGE FOR This
            BECAUSE VIDEOS DO NOT HAVE THE SKIP AHEAD FUNCTIONALITY WITH AZURE STORAGE 
            THIS IS DUE TO THE WAY AZURE BLOB STORAGES STREAMS THE MP4 -->
               <source src="https://harrellspublic2024.azurewebsites.net/Assets/Images/CoreValuesHome.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <h6 style="text-align: right;margin-top:20px; margin-right:20px"><a
                    class="DIN2014 greenBackground whiteText"
                    style="cursor:pointer;font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                    (click)="CloseCoreValuesModal()">Close</a></h6>
        </div>
    </div>
    <!-- End Core Values Modal -->

    <!-- Our Why Modal -->
    <div id="ourWhyModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content coreValuesModalVideoModalMobile">
            <video id="ourWhyVideo" class="coreValuesModalMobile" width="800" height="500" controls>
                <!-- MUST PATH TO A VIRTUAL DIRECTORY AND NOT AZURE STOREAGE FOR This
            BECAUSE VIDEOS DO NOT HAVE THE SKIP AHEAD FUNCTIONALITY WITH AZURE STORAGE 
            THIS IS DUE TO THE WAY AZURE BLOB STORAGES STREAMS THE MP4 -->
               <source src="https://harrellspublic2024.azurewebsites.net/Assets/Images/OurWhyHome.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <h6 style="text-align: right;margin-top:20px; margin-right:20px"><a
                    class="DIN2014 greenBackground whiteText"
                    style="cursor:pointer;font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                    (click)="CloseOurWhyModal()">Close</a></h6>
        </div>
    </div>
    <!-- End Our Why Modal -->

    <!-- Celebration Modal -->
    <div id="celebrationModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content coreValuesModalVideoModalMobile">
            <video id="celebrationVideo" class="coreValuesModalMobile" width="800" height="500" controls>
                <!-- MUST PATH TO A VIRTUAL DIRECTORY AND NOT AZURE STOREAGE FOR This
            BECAUSE VIDEOS DO NOT HAVE THE SKIP AHEAD FUNCTIONALITY WITH AZURE STORAGE 
            THIS IS DUE TO THE WAY AZURE BLOB STORAGES STREAMS THE MP4 -->
                <source src="https://harrellspublic2024.azurewebsites.net/Assets/Images/CelebrationOfLifeHome.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <h6 style="text-align: right;margin-top:20px; margin-right:20px"><a
                    class="DIN2014 greenBackground whiteText"
                    style="cursor:pointer;font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                    (click)="CloseCelebrationModal()">Close</a></h6>
        </div>
    </div>
    <!-- End Celebration Modal -->



    <div class="d-block d-md-none"
        style="background-size: cover; background-position:center; height:100vw; padding-top:10.8vw"
        [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'Home_header.gif)'}">
        <div class="row">
            <div style="width:22%"></div>
            <div class="text-center whiteText" style="width:56%">
                <h1 class="DINNextLTPro-Black whiteText" style="font-size:43px; text-transform: uppercase;">AGRONOMIC
                    SOLUTIONS<br>FOR GROWING PROS</h1>
            </div>
            <div style="width:22%"></div>
        </div>
        <div class="row text-center" style="padding-top:2%; padding-bottom:3%">
            <h3><a class="DIN2014Bold greenBackground whiteText"
                    style="margin-right:15px;font-size:20px;font-weight:700;padding:8pt; text-decoration: none !important"
                    href='/products'>VIEW PRODUCTS</a>
                <a class="DIN2014Bold greenBackground whiteText"
                    style="margin-left:15px;font-size:20px;font-weight:700;padding:8pt; text-decoration: none !important"
                    href='/findrep'>FIND YOUR REP</a>
            </h3>
        </div>
    </div>
    <div class="d-none d-md-block">
        <video id="howItWorksVideo" width="100%" style="height:37vw; object-fit: cover; object-position: center;"
            autoplay muted loop>
            <source src="{{this.baseImagePaths + 'home.mp4'}}" type="video/mp4">
            Your browser does not support the video tag.
        </video>
        <div class="row text-center" style="position:absolute; top:23vw; width: 100%; margin-left:0px">
            <div class="row" style="margin-left:0px">
                <div style="width:22%"></div>
                <div class="text-center whiteText" style="width:56%">
                    <h1 class="DINNextLTPro-Black whiteText" style="font-size:43px; text-transform: uppercase;">
                        AGRONOMIC
                        SOLUTIONS<br> FOR GROWING PROS</h1>
                </div>
                <div style="width:22%"></div>
            </div>
            <h3><a class="DIN2014Bold greenBackground whiteText"
                    style="margin-right:15px;font-size:20px;font-weight:700;padding:8pt; text-decoration: none !important"
                    href='/products'>VIEW PRODUCTS</a>
                <a class="DIN2014Bold greenBackground whiteText"
                    style="margin-left:15px;font-size:20px;font-weight:700;padding:8pt; text-decoration: none !important"
                    href='/findrep'>FIND YOUR REP</a>
            </h3>
        </div>
    </div>
    <div class="row">
        <div style="padding-right:0px; padding-left:0px; padding-top:70px; padding-bottom:70px">
            <h3 class="DIN2014Regular blackText harrellsProvides">
                At Harrell’s, we are more than just a supplier of industry-leading fertilizers, plant protection products, and specialty solutions; we are a true partner for success, committed to supporting your growth and helping your business thrive.<br><br>
                Founded in 1941 and now 100% employee-owned, Harrell’s has grown from a small family business into a nationwide leader. Guided for generations by the Harrell family, from Ormond Harrell to Jack Harrell, Sr., then Jack Harrell, Jr., and now, Jack Harrell, III, the legacy of integrity, service, and deep agronomic knowledge continues to shape everything we do today.<br><br>
                Whether you're managing a golf course, running a lawn care company, or growing plants or specialty crops, we provide the expertise, innovation, and trusted products you need to succeed.
            </h3>
        </div>
    </div>
    <div class="d-none d-md-block">
        <div class="row weArePrfofessionalGrowersOuterRow">
            <div class="col-lg-6" style="padding-right:0px; padding-left:0px">
                <h3 class="greenText Caecilia76BoldItalic weServeProfessionalGrowers">Science-Backed Solutions.<br>
                    Relationship-Driven Service.</h3>
            </div>
            <div class="col-lg-6" style="padding-right:0px; padding-left:0px">
                <h3 class="blueText DIN2014Bold weServeProfessionalGrowersDetail" style="line-height:53px">POLYON®
                    Controlled-Release Fertilizer</h3>
                <h3 class="blueText DIN2014Bold weServeProfessionalGrowersDetail" style="line-height:53px">Custom
                    Blended Fertilizers</h3>
                <h3 class="blueText DIN2014Bold weServeProfessionalGrowersDetail" style="line-height:53px">Trusted
                    Pesticides & Herbicides</h3>
                <h3 class="blueText DIN2014Bold weServeProfessionalGrowersDetail" style="line-height:53px">Unmatched
                    Industry Expertise </h3>
            </div>
        </div>

        <div class="row" style="margin-top:60px;">
            <div id="letsGrowTogether" class="col-lg-4 whiteText blueBackground"
                style="padding-bottom: 50px !important;">
                <h4 class="Caecilia76BoldItalic youllFindThatOuter"
                    style="text-align: LEFT; margin-left:20%; font-size:28px; line-height: 36px;">
                    You’ll Find That Harrell’s is Different</h4>
                <h6 class="DIN2014Regular textWhite"
                    style="margin-top:5%; text-align:left; margin-left:20%; margin-right:20%; font-size:19px;line-height: 30px; padding-bottom:20px">
                    We are committed to providing you with more than just products during your growing season.</h6>
                <h3 class="letsGrowTogetherButton" style="margin-left:20%"><a
                        class="DINNextLTPro-Black whiteBackground blueText connectWithRepMobile"
                        style="display:block; width:230px; font-size:20pt; padding:6px 22px; text-decoration: none !important"
                        href='/findrep'>FIND YOUR REP</a></h3>
            </div>
            <div id="letsGrowRightPic" class="col-lg-8" style="padding-right:0px; padding-left:0px">
                <img style="width:100%; height:100%; object-fit: cover;object-position: center;"
                    src="{{this.baseImagePaths + 'argonomic-products.jpg'}}" alt="argonomic-solutions">
            </div>
        </div>
    </div>


    <div class="row g-0 lightCremeBackground text-center" style="padding-top:80px">
        <h2 class="Caecilia76BoldItalic greenText" style="font-size: 28px; font-weight: 700;">Dig Deeper</h2>
    </div>
    <div class="row g-0 lightCremeBackground text-center">
        <h3 class="DIN2014Regular blackText"
            style="font-size: 19px; line-height: 27px; letter-spacing:.38px; font-weight: 400;">Whether you’re a
            long-term
            partner or just getting to know us, we welcome you to learn more about our foundation & culture.</h3>
    </div>
    <div class="lightCremeBackground pt-4 pb-5">
        <div class="row g-0 text-center" style="margin: auto; width:90%">
            <div class="text-center p-0" style="margin:10px !important">
                <div style="display:inline-block;cursor:pointer" (click)="OpenCoreValuesModal()">
                    <img class="digDeeperImage" src="{{this.baseImagePaths + 'values.jpg'}}" alt="corevaluesimage"
                        style="cursor:pointer; padding:10px">
                    <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">Our Values</h4>
                    <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">&nbsp;</h4>
                </div>
                <div style="display:inline-block; cursor:pointer" (click)="OpenOurWhyModal()">
                    <img class="digDeeperImage" src="{{this.baseImagePaths + 'why.jpg'}}" alt="ourwhyimage"
                        style="cursor:pointer; padding:10px">
                    <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">Our Why</h4>
                     <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">&nbsp;</h4>
                </div>
                <div style="display:inline-block;cursor:pointer" (click)="OpenCelebrationModal()">
                    <img class="digDeeperImage" src="{{this.baseImagePaths + 'celebration.jpg'}}" alt="celebrationimage"
                        style="cursor:pointer; padding:10px">
                    <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">Jack Harrell, Jr.</h4>
                    <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">Celebration Of Life</h4>
                </div>
            </div>
        </div>
    </div>
    <div class="d-none d-md-block">
        <div class="row text-center">
            <div class="col-lg-4 blackText blueBackground pt-3 pb-3" style="margin-bottom:-1px">
                <div class="everythingYouNeedOuter">
                    <h4 class="Caecilia76BoldItalic whiteText everythingYouNeed">
                        Trusted Products for Healthy Growth</h4>
                    <h3 class="everythingYouNeedViewAllProducts">
                        <a class="DINNextLTPro-Black  whiteBackground greenText"
                            style="font-size:20pt;padding:6px 22px; text-decoration: none !important"
                            href='/products'>VIEW
                            ALL
                            PRODUCTS</a>
                    </h3>
                </div>
            </div>
            <div class="col-lg-4 blackText blueBackground pt-3 pb-5 d-none d-md-block">
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Polyon&reg;</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Granular Fertilizer</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Foliar Fertilizer</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Soluble Fertilizer</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Fungicides</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Herbicides</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Insecticides</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Biologicals</h4>
            </div>
            <div class="col-lg-4 blackText blueBackground pt-3 pb-5 d-none d-md-block">
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Pigments & Paints</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Adjuvants</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Water Conditioning</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Wetting Agents</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Soil Conditioning</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Soil Amendments</h4>
                <h4 class="DIN2014Bold whiteText"
                    style="margin-top:5%; text-align:left; margin-left:20%; font-size:21pt; line-height:25pt">
                    Seed</h4>
            </div>
        </div>
    </div>

    <div class="row text-center">
        <div class="col-lg-4 blackText cremeBackground expertiseContainer">
            <img class="expertiseIcons" src="{{this.baseImagePaths + 'harrells-expertise-icon.png'}}"
                alt="harrells-expertise-icon">
            <h4 class="DIN2014Bold blueText cremeBackground" style="margin-top:5%; font-size:21pt; line-height: 25pt;">
                ACCESS TO
                <br>EXPERTISE
            </h4>
            <h6 class="DIN2014Regular textWhite cremeBackground"
                style="margin-top:5%; font-size:19pt; line-height: 32pt;">
                Tap into our
                deep well<br> of agronomic knowledge<br> to find the best<br> programs & products<br> for your needs
            </h6>
        </div>
        <div class="col-lg-4 blackText cremeBackground specializedContainer">
            <img class="expertiseIcons" src="{{this.baseImagePaths + 'harrells-solutions-icon.png'}}"
                alt="harrells-solutions-icon">
            <h4 class="DIN2014Bold blueText cremeBackground" style="margin-top:5%; font-size:21pt; line-height: 25pt;">
                SPECIALIZED
                <br>SOLUTIONS
            </h4>
            <h6 class="DIN2014Regular textWhite cremeBackground"
                style="margin-top:5%; font-size:19pt; line-height: 32pt;">Let us listen
                to<br> understand your unique<br> challenges and goals<br> so that we can offer<br> personalized
                support.</h6>
        </div>
        <div class="col-lg-4 blackText cremeBackground partnershipContainer">
            <img class="expertiseIcons" src="{{this.baseImagePaths + 'harrells-partnership-icon.png'}}"
                alt="harrells-partnership-icon">
            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:21pt; line-height: 25pt">A TRUE
                <br>PARTNERSHIP
            </h4>
            <h6 class="DIN2014Regular textWhite " style="margin-top:5%; font-size:19pt; line-height: 32pt;">
                Experience a
                customer-<br> first approach that<br> always values long-<br> term relationships over<br>
                transactions.
            </h6>
        </div>
        <div class="col-lg-4 cremeBackground"></div>
        <div class="d-block d-md-none cremeBackground" style="padding-bottom:70px">
            <a class="DINNextLTPro-Black  whiteBackground greenText"
                style="font-size:20pt;padding:6px 22px; text-decoration: none !important" href='/products'>VIEW
                ALL
                PRODUCTS</a>
        </div>
    </div>
    <div class="d-none d-md-block">
        <div class="row" style="background-size: cover; background-position:center; padding-top:5%; padding-bottom:5%"
            [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern.png)'}">
            <div class="col-lg-9 blackText ">
                <h4 class="Caecilia76BoldItalic whiteText"
                    style="text-align: left; margin-left:10%; font-size:28pt; line-height:46pt">
                    Let our team help you build a custom agronomic program.
                </h4>
            </div>
            <div class="col-lg-3  ">
                <h4 class="contactUsButton"><a class="DIN2014Bold  whiteBackground greenText"
                        style="font-size:20pt;padding:6px 22px; text-decoration: none !important"
                        href='/contact'>CONTACT
                        US</a>
                </h4>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5" style="padding-right:0px; padding-left:0px">
                <img style="width:100%; object-fit: cover; max-height:80vh"
                    src="{{this.baseImagePaths + 'harrells-polyon-controlled-release-fertilizer.jpg'}}"
                    alt="harrells-polyon-controlled-release-fertilizer">
            </div>
            <div class="col-lg-7 blackText exclusiveOuter pb-3" style="padding-right:0px; padding-left:0px">
                <h3 class="Caecilia76BoldItalic harrellsExclusive"
                    style="text-align: center; margin-top:10%; font-size:28pt; line-height: 37pt;">Harrell’s is
                    the exclusive United<br>States owner, formulator<br>and distributor of POLYON®<br>controlled-release
                    fertilizer.</h3>
                <h3 style="margin-top:5%"><a class="DIN2014Bold blueBackground whiteText"
                        style="font-size:20pt;padding:6px 22px; text-decoration: none !important"
                        (click)="OpenhowItWorksModal()">SEE HOW
                        IT
                        WORKS</a></h3>
            </div>
        </div>
    </div>
    <div class="row text-center d-none d-md-block">
        <div class="col-12" style="margin-top:4%">
            <img style="width:40pt" src="{{this.baseImagePaths + 'harrells-quote-icon.png'}}" alt="harrells-quote-icon">
        </div>
        <div class="col-12" style="margin-top:1%">
            <h2 class="DIN2014Regular"
                style="text-align: center; margin-left:10%; margin-right:10%;font-size:30pt; line-height:40pt">“I cannot
                say enough about Harrell’s! From the sales team, to management, to the guys that select my
                products for me, everyone is so courteous. Harrell’s feels like family and they make you feel that way,
                too.”</h2>
        </div>
        <div class="col-12">
            <h6 class="Caecilia76BoldItalic greenText mb-5"
                style="text-align: center; font-size:20pt; line-height: 38pt">
                Brian Christensen, Customer</h6>
        </div>
    </div>
    <div class="blueBackground">
        <div class="col-xs-12 whiteText pt-5" style="padding-right:0px; padding-left:0px; padding-top:5%">
            <h3 class="Caecilia76BoldItalic" style="font-size: 28pt; font-weight: 700;">
                Ready to Become a Customer?</h3>
            <h6 class="DIN2014Regular whiteText"
                style="text-align:center; margin-left:20%; margin-right:20%; font-size: 16px; line-height: 22px; font-weight: 700; color:#FFFFFC; opacity: 55%; padding-bottom:20px">
                Submit the form below and we will reach out to you with more information.</h6>
        </div>
        <div class="row letUsFormContainer">
            <div class="row" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="First Name*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    [(ngModel)]="this.firstNameRepMatch">
                <input type="text" placeholder="Last Name*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.lastNameRepMatch">
            </div>
            <div class="row" style="margin:auto;padding-bottom:26px">
                <input type="text" placeholder="Company Name*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    [(ngModel)]="this.companyRepMatch">
                <input type="text" placeholder="Job Title*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.titleRepMatch">
            </div>
            <div class="row" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="Phone Number*"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular" [(ngModel)]="this.phoneRepMatch">
                <input type="text" placeholder="Email*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.emailRepMatch">
            </div>
            <div class="row" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="City*"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular" [(ngModel)]="this.cityRepMatch">
                <input type="text" placeholder="State*"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                    [(ngModel)]="this.stateRepMatch">
            </div>
            <div class="row" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="Zip*"
                    style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400; border: 1px solid #FFF;background: rgba(0, 0, 0, 0.03);backdrop-filter: blur(2.5px);width:400px; height:54px;margin-right:10px"
                    class="whitePlaceholder blueBackground whiteText Din2014Regular" [(ngModel)]="this.zipRepMatch">
            </div>

            <h4 class="Din2014Regular whiteText"
                style="margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                Choose
                Your Market(s)*</h4>

            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="golfRepMatch"
                    (change)="golfRepMatch = !golfRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Golf</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="horticultureRepMatch"
                    (change)="horticultureRepMatch = !horticultureRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Horticulture</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="sportsTurfRepMatch"
                    (change)="sportsTurfRepMatch = !sportsTurfRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Sports Turf</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="specialtyAgRepMatch"
                    (change)="specialtyAgRepMatch = !specialtyAgRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Specialty Ag</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="lawnCareRepMatch"
                    (change)="lawnCareRepMatch = !lawnCareRepMatch">
                <h4 class="Din2014Regular whiteText"
                    style="opacity:.8; display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Lawn Care</h4>
            </div>

            <textarea class="whitePlaceholder blueBackground whiteText DIN2014Regular textareaCanWeHelpMobile"
                [(ngModel)]="this.commentsRepMatch" style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; 
                margin-left:10px; letter-spacing:.38px; font-weight:400; 
                border: 1px solid #FFF;width:820px; height:100px;margin-right:10px"
                placeholder="How Can We Help?"></textarea>
            <div class="row whiteBackground"
                style="margin-top:26px; text-align: center;width:auto; margin-left:10px; padding:0px">
                <button class="DINNextLTPro-Black blueText"
                    [disabled]="this.firstNameRepMatch == '' || this.lastNameRepMatch == '' || this.emailRepMatch == '' || this.phoneRepMatch == '' || this.companyRepMatch == '' || this.titleRepMatch == '' || this.cityRepMatch == '' || this.stateRepMatch == ''|| this.zipRepMatch == ''"
                    [ngClass]="this.firstNameRepMatch == '' || this.lastNameRepMatch == '' || this.emailRepMatch == '' || this.phoneRepMatch == '' || this.companyRepMatch == '' || this.titleRepMatch == '' || this.cityRepMatch == '' || this.stateRepMatch == ''|| this.zipRepMatch == '' ? 'greyDisabled':'' "
                    style="padding:10px 10px 7px 10px;font-size:20px; font-weight: 900; line-height:normal; text-decoration: none !important"
                    (click)="sendEmail()">SUBMIT</button>
            </div>
        </div>
    </div>
    <div class="row text-center d-none d-md-block">
        <div class="col-12" style="padding-left:0px; padding-right:0px">
            <img style="width:100%;" src="{{this.baseImagePaths + 'harrells-fertilizer.jpg'}}"
                alt="harrells-fertilizer">
        </div>
    </div>
    <div class="row" style="margin-top:50px; margin-bottom:50px">
        <div class="col-12 dontGoItAloneOuter">
            <h2 class="DIN2014Bold dontGoItAlone d-block d-md-none">CONNECT WITH HARRELL’S AND YOU’LL BE BACKED BY
                RESEARCH, SCIENCE, AND
                SUPPORT YOU NEVER THOUGHT POSSIBLE.
            </h2>
            <h2 class="DIN2014Bold dontGoItAlone d-none d-md-block">DON'T GO AT IT ALONE. GROWING CAN BE FICKLE
                AND FRUSTRATING. CONNECT WITH HARRELL’S AND YOU’LL BE BACKED BY RESEARCH, SCIENCE, AND
                SUPPORT YOU NEVER THOUGHT POSSIBLE.
            </h2>
            <h3 style="margin-top:20px;"><a class="DINNextLTPro-Black greenBackground whiteText connectWithRepMobile"
                    style="font-size:20pt;padding:6px 22px; text-decoration: none !important" href='/findrep'>CONNECT
                    WITH
                    YOUR REP</a></h3>
        </div>
    </div>
    <div class="row" style="background-size: cover; background-position:center; padding-top:5%; padding-bottom:5%"
        [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern.png)'}">
        <div class="col-lg-2"></div>
        <div class="col-lg-2 pt-4 d-none d-md-block">
            <div style="width:12vw; height:14vw; background-color:lightgrey; margin:10%">

                <img style="width:100%; object-fit: cover;" src="{{this.baseImagePaths + 'agronomicThumb.jpg'}}"
                    alt="argonomic-solutions">
            </div>
        </div>
        <div class="col-lg-8 argOuter" style="text-align: left;">
            <h2 class="d-none d-md-block Caecilia76BoldItalic whiteText" style="font-size:34pt; line-height:50pt">
                Access our 300+ page<br>Agronomic Resource Guide</h2>
            <h2 class="d-block d-md-none Caecilia76BoldItalic whiteText"
                style="font-size:16px; line-height:27px; margin-right:20px; margin-top:27px">Access our
                300+ page Agronomic Resource Guide</h2>
            <h3 style="padding-top: 20px; padding-bottom:20px;"><a class="DIN2014Bold blueBackground whiteText"
                    style="margin-bottom:20%;font-size:20pt;padding:6px 22px; text-decoration: none !important"
                    href='https://online.flippingbook.com/view/994927029/' target="_blank">GET THE GUIDE</a></h3>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6 cremeBackground">
            <h2 class="DIN2014Bold blueText"
                style="padding-top:5%; text-align:left; margin-left:10%;font-size:28pt; line-height:37pt">
                Manage<br>Your<br>Account<br>Online
            </h2>
            <h3 class="pb-3" style="text-align:left; margin-left:10%;padding-top:50px"><a
                    class="DIN2014Bold blueBackground whiteText"
                    style="font-size:20pt;padding:6px 22px; text-decoration: none !important"
                    href='/myharrellslogin'>LOGIN</a>
            </h3>
        </div>
        <div class="col-lg-6" style="background-size: cover; background-position:center; padding-bottom:5%"
            [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-educational-resources.jpg)'}">
            <h2 class="Caecilia76BoldItalic whiteText"
                style="padding-top:5%; text-align:left; margin-left:10%; font-size:28pt; line-height:37pt">Get Access
                <br>
                to Our Latest
                <br> Educational <br> Resources
            </h2>
            <h3 style="text-align: left; margin-left:10%; padding-top:50px"><a
                    class="DIN2014Bold greenBackground whiteText"
                    style="font-size:20pt;padding:6px 22px; text-decoration: none !important" href='/education'>LET'S
                    GO</a>
            </h3>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 d-none d-md-block" style="margin-top:5%; margin-bottom:5%">
            <h4 class="Din2014Regular blackText"
                style="text-align:center; margin-left:20%; margin-right:20%; font-size:19pt; line-height:32pt">
                Since 1941, generations of Harrell family members have been committed to supporting growing
                professionals through trusted solutions and relationships that stand the test of time. Today, Harrell’s
                is 100% employee-owned and still focused on serving people well. Our team of sales professionals works
                alongside our customers as a true partner for success, drawing on a deep well of experience and
                first-hand knowledge and collaborating with our in-house technical team of PhDs to help problem-solve
                and innovate solutions that propel you forward.
            </h4>
        </div>
    </div>
</div>
